import React from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const WhiteCheckbox = (props: any) => (
  <Checkbox
    {...props}
    icon={
      <div
        style={{
          width: "20px",
          height: "20px",
          border: "2px solid white",
          borderRadius: "2px",
          backgroundColor: "transparent",
        }}
      />
    }
    checkedIcon={
      <div
        style={{
          width: "20px",
          height: "20px",
          border: "2px solid white",
          borderRadius: "2px",
          backgroundColor: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span style={{ color: "black", fontSize: "14px", fontWeight: "bold" }}>✓</span>
      </div>
    }
    style={{
      color: "white",
      padding: "9px",
    }}
  />
);

interface AwardsEntryCheckboxProps {
  name: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  label: React.ReactNode;
  description?: string;
}

const AwardsEntryCheckbox: React.FC<AwardsEntryCheckboxProps> = ({
  name,
  checked,
  onChange,
  onBlur,
  label,
  description,
}) => {
  return (
    <FormControlLabel
      control={
        <div className="-mt-1.5">
          <WhiteCheckbox name={name} checked={checked} onChange={onChange} onBlur={onBlur} />
        </div>
      }
      label={
        <div className="flex flex-col pl-0 md:pl-2">
          <span>{label}</span>
          {description && <span className="text-12 text-popokotea/50">{description}</span>}
        </div>
      }
      className="!items-start"
    />
  );
};

export default AwardsEntryCheckbox;
